import moment from 'moment';
import { useSelector } from 'react-redux';
import { CustomSelect } from '../../../../UsersList/components/CustomSelect';
import { PlansCombobox } from '../../../components';
import { JobStatus, jobStatusOptions } from '../../../shared/constants';
import { FormCard } from '../../../shared/FormCard';
import { InfoRow } from '../../../shared/InfoRow';

export const JobDetailsCard = ({ job, handleRecruiterChange, handleJobStatusChange }) => {
  const allMetadata = useSelector((state) => state.users.allMetadata);

  return (
    <FormCard title="Job Details">
      <div
        style={{ display: 'flex', gap: '20px', justifyContent: 'center', alignItems: 'flex-end' }}
      >
        <CustomSelect
          key="recruiter"
          id="recruiterEmail"
          label="Recruiter"
          options={[
            { code: '', name: 'No Recruiter Selected' },
            ...(allMetadata?.permanentRecruitersEmail || []).map((recruiterEmail) => ({
              code: recruiterEmail,
              name: recruiterEmail,
            })),
          ]}
          value={job?.recruiterEmail || ''}
          onChange={handleRecruiterChange}
        />

        <CustomSelect
          key="status"
          id="status"
          label="Job Status"
          options={jobStatusOptions
            .map((status) => ({
              code: status.code,
              name: status.name,
            }))
            .filter((it) => job?.status === JobStatus.SUSPENDED || it.code !== JobStatus.SUSPENDED)}
          value={job?.status || ''}
          onChange={handleJobStatusChange}
          isReadonly={job?.status === JobStatus.SUSPENDED}
        />

        <PlansCombobox label="Plan" isReadonly value={job?.planId} />
      </div>
      <div>
        <InfoRow>
          <span className="semi-bold">Permanent Job ID:</span>
          <span>{job?.id}</span>
        </InfoRow>

        <InfoRow>
          <span className="semi-bold">Office Name:</span>
          {job?.officeId ? (
            <a href={`/user/dentist/${job?.officeId}`}>{job?.officeName || '-'}</a>
          ) : (
            <span>-</span>
          )}
        </InfoRow>

        <InfoRow>
          <span className="semi-bold">DSO Name:</span>
          <span>-</span>
        </InfoRow>

        <InfoRow>
          <span className="semi-bold">Created At:</span>
          <span>
            {job?.createdAt ? moment(job.createdAt).format('dddd, MMMM Do, YYYY, h:mm:ss A') : '-'}
          </span>
        </InfoRow>

        <InfoRow>
          <span className="semi-bold">Created By:</span>
          <span>{job?.createdBy || '-'}</span>
        </InfoRow>

        <InfoRow>
          <span className="semi-bold">Updated At:</span>
          <span>
            {job?.updatedAt ? moment(job.updatedAt).format('dddd, MMMM Do, YYYY, h:mm:ss A') : '-'}
          </span>
        </InfoRow>

        <InfoRow>
          <span className="semi-bold">Closed At:</span>
          {job?.closedAt ? moment(job.closedAt).format('dddd, MMMM Do, YYYY, h:mm:ss A') : '-'}
        </InfoRow>

        <InfoRow>
          <span className="semi-bold">Closed By:</span>
          <span>{job?.closedBy || '-'}</span>
        </InfoRow>
      </div>
    </FormCard>
  );
};
